import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  ContextMenu,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Page,
  PageSettingsModel,
  Reorder,
  Resize,
  Edit,
  EditSettingsModel,
  Inject,
  Toolbar,
  Sort,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import { all_information, loadingShow } from '../../App';
import {
  AddOperations,
  DeleteOperations,
  EditOperations,
  getOperations,
} from '../../services/Operations/OperationServices';
import Message from '../../utils/Message/Message';
import { MdAssignmentTurnedIn } from 'react-icons/md';
import {
  ButtonComponent,
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import {
  MultiSelectComponent as MultiSelectC,
  DropDownListComponent,
  DropDownList,
} from '@syncfusion/ej2-react-dropdowns';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import { ThemeContext } from '../../context/theme.context';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import { Query } from '@syncfusion/ej2-data';
import { BsSearch } from 'react-icons/bs';
import GlobalSearch from '../../components/GlobalSearch';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { applyTheRule } from '../../utils/BussinesRuleBuilder';
import { getPriority } from '../../utils/GetPriorityColor';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsPlanSelected,
  setSearchCaseGantt,
  setSearchCaseOp,
  setSearchCaseOrder,
} from '../../redux/search.slice';
import { getParamsDD } from '../../utils/GridParams';
import {
  GlobalDropDown,
  GlobalMultiSelection,
} from '../../components/GlobalDropDown';
import GlobalDialog from '../../components/GlobalDialog';
import SearchBox from '../../components/GlobalSearchBox';
import { getFilteredOrder } from '../../utils/Methods/methods';
interface IProps {
  needDidMount: boolean;
  outter_asset_code?: string | undefined;
}
let init_query: string = '';
let model: Array<any> = [];
let buttonShiftAssignment: ButtonPropsModel[];
let current_query: string = '';
const editOptions: EditSettingsModel = {
  allowEditing: true,
  allowAdding: false,
  allowDeleting: true,
  showDeleteConfirmDialog: true,
};
let priorityFMCComValue: Array<any> = [];
let statusFMCComValue: Array<any> = [];
let typeFMCComValue: Array<any> = [];
let respFMCComValue: Array<any> = [];
let assetFMCComValue: Array<any> = [];
let statusFMCCom: MultiSelectC = new MultiSelectC({});
let typeFMCCom: MultiSelectC = new MultiSelectC({});
let respFMCCom: MultiSelectC = new MultiSelectC({});
let assetFMCCom: MultiSelectC = new MultiSelectC({});
const FilterOptions: FilterSettingsModel = { type: 'Menu' };
const pageOptions: PageSettingsModel = {
  currentPage: 1,
  pageSize: 100,
  pageCount: 10,
  pageSizes: false,
};
let current_page: number =
  250 / (pageOptions.pageSize !== undefined ? pageOptions.pageSize : 1);
let gridCPOp: GridComponent;
let plan_id: number = -1;
let selectedChips: Array<any> = [];
let selectedChipValues: Array<any> = [];
let dropDownListObjectShiftElment: DropDownListComponent;
let queryOfAsset = new Query().take(20);
let current_page_range = '1$250';
let theQueryStatuses = '';
let theQueryPrioritys = '';
let theQueryAsset = '';
let theQueryType = '';
let theQueryResp = '';
let theQueryDate = '';
let theQuerySearch = '';
let theQueryPlanId = '';
let theQueryOutterAsset = '';
let toolbarOptions: any;
var contextMenuItems = [
  {
    text: 'Show Materials',
    tooltipText: 'view',
    prefixIcon: 'e-view',
    id: 'materials',
  },
];
let searchText: string = '';
let searchTextBox: TextBoxComponent;
const Operations = ({ outter_asset_code }: IProps) => {
  const dispatch = useDispatch();
  const reduxSearchS = useSelector((state: any) => state.search);
  const [data, setData] = useState<Array<any>>([]);
  const [PriorityColorData, setPriorityColorData] = useState<Array<any>>([]);
  const [hideDeleteDialog, setHideDeleteDialog] = useState(false);
  const [schdeduleStartDateVal, setSchdeduleStartDateVal] = useState<Date[]>();
  const [searchCase, setSearchCase] = useState('');
  searchText = reduxSearchS.searchCaseOperation;
  $('#operation-search').val(searchText);
  const context = React.useContext(ThemeContext);
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          ref={(scope: TextBoxComponent) => (searchTextBox = scope)}
          type={'text'}
          id='work_operations_search'
          autocomplete='off'
          showClearButton
          placeholder='Search'
          value={searchText}
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search}
          />
        </div>
      </div>
    );
  };
  function getSecondNumber(sequence: string): number {
    const parts = sequence.split('-');
    const secondPart = parts[1]?.trim();
    return secondPart ? Number(secondPart) : NaN;
  }
  const shiftAssignment = () => {
    let selectedElement = gridCPOp.getSelectedRecords();
    if (
      dropDownListObjectShiftElment.value === undefined ||
      dropDownListObjectShiftElment.value === null
    ) {
      Message.error('You should select a shift');
      return;
    }
    if (selectedElement.length > 0) {
      const obj = [
        ...selectedElement.map((el: any) => {
          return {
            operationId: el.operationId,
            shift: dropDownListObjectShiftElment.text,
            shiftId: dropDownListObjectShiftElment.value,
            createdBy: all_information.user_id,
          };
        }),
      ];

      EditOperations(obj)
        .then(() => {
          Message.success('Success');
          loadingShow(false);
          getBusinessLogic();
          setHideDeleteDialog(false);
        })
        .catch((err: any) => {
          if (err.response) {
            Message.error(
              err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
          loadingShow(false);
        });
    }
  };
  const assignButton = () => {
    return (
      <ButtonComponent
        onClick={() => {
          let selectedElement = gridCPOp.getSelectedRecords();
          if (selectedElement.length > 0) {
            setHideDeleteDialog(true);
          } else {
            Message.error('Must selected a operation at least');
          }
        }}
      >
        <MdAssignmentTurnedIn /> Shift Assign
      </ButtonComponent>
    );
  };

  const priorityColorChip = () => {
    return (
      <div
        className='row md-6'
        style={{
          alignSelf: 'end',
          display: 'flex',
          right: 220,
        }}
      >
        <ChipListComponent
          id='chip-filter-cp'
          selectedChips={selectedChipValues}
          selection='Multiple'
          click={isChipClicked2.bind(this)}
        >
          <ChipsDirective>
            {PriorityColorData.map((el: any, index: number) => {
              return (
                <ChipDirective
                  text={`P${el.priority_code.trim()}`}
                  cssClass={`e-chip-text${el.priority_code.trim()}`}
                  key={index}
                />
              );
            })}
          </ChipsDirective>
        </ChipListComponent>
      </div>
    );
  };
  toolbarOptions = [
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    {
      text: 'Show Order',
      tooltipText: '',
      id: 'show_order',
    },
    {
      text: 'Show Resources',
      tooltipText: '',
      id: 'show_resources',
    },
    { template: priorityColorChip.bind(this), align: 'Right' },
    'ColumnChooser',
    { template: assignButton.bind(this) },
    { template: template, align: 'Right' },
  ];
  buttonShiftAssignment = [
    {
      click: () => {
        shiftAssignment();
      },
      buttonModel: {
        content: 'Yes',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideDeleteDialog(false);
      },
      buttonModel: {
        content: 'No',
        isPrimary: false,
      },
    },
  ];
  const isChipClicked2 = (e: any) => {
    if (e.selected) {
      selectedChips.push(e.index + 1);
      selectedChipValues.push(e.index);
    } else {
      selectedChips.splice(selectedChips.indexOf(e.index + 1), 1);
      selectedChipValues.splice(selectedChipValues.indexOf(e.index), 1);
    }
    buildQuery(true, searchText);
  };
  const getBusinessLogic = async () => {
    current_query = await applyTheRule('uw_operation', 'Cloud Planner');
    buildQuery(true, searchText);
  };
  const search = () => {
    if (searchText === '') {
      dispatch(setSearchCaseOp(''));
    }
    if (searchText !== '' || current_query !== '') {
      buildQuery(true, searchText);
    }
  };
  const buildQuery = (clearRequest: boolean, theSearchText: string) => {
    current_query = current_query.replace(theQueryPrioritys, '');
    current_query = current_query.replace(theQueryAsset, '');
    current_query = current_query.replace(theQueryDate, '');
    current_query = current_query.replace(theQueryResp, '');
    current_query = current_query.replace(theQueryStatuses, '');
    current_query = current_query.replace(theQueryType, '');
    current_query = current_query.replace(theQuerySearch, '');
    current_query = current_query.replace(theQueryPlanId, '');
    current_query = current_query.replace(theQueryOutterAsset, '');
    theQueryPrioritys = '';
    theQueryStatuses = '';
    theQueryAsset = '';
    theQueryResp = '';
    theQueryType = '';
    theQueryDate = '';
    theQuerySearch = '';
    var thePrioritysMerged = selectedChips.concat(priorityFMCComValue);
    var thePurePrioritys = [...new Set(thePrioritysMerged)];
    var thePrioritys = thePurePrioritys?.toString();
    var theStatuses = statusFMCCom?.value?.toString();
    var theTypes = typeFMCCom?.value?.toString();
    var theResp = respFMCCom?.value?.toString();
    var theAssets = assetFMCCom?.value?.toString();
    var theDate = schdeduleStartDateVal;
    var o_asset_code = outter_asset_code;
    if (thePrioritys !== '' && thePrioritys !== undefined) {
      if (current_query !== '') {
        theQueryPrioritys = addToQuery(
          'priority',
          'in',
          'andWhere',
          thePrioritys?.toString(),
          theQueryPrioritys
        );
      } else {
        theQueryPrioritys = addToQuery(
          'priority',
          'in',
          'where',
          thePrioritys?.toString(),
          theQueryPrioritys
        );
      }
    }
    if (theStatuses !== '' && theStatuses !== undefined) {
      if (current_query !== '') {
        theQueryStatuses = addToQuery(
          'status_code',
          'in',
          'andWhere',
          theStatuses?.toString(),
          theQueryStatuses
        );
      } else {
        theQueryStatuses = addToQuery(
          'status_code',
          'in',
          'where',
          theStatuses?.toString(),
          theQueryStatuses
        );
      }
    }
    if (plan_id !== 0 && plan_id !== -1) {
      if (current_query !== '') {
        theQueryPlanId = addToQuery(
          'ID',
          '=',
          'andWhere',
          plan_id?.toString(),
          theQueryPlanId
        );
      } else {
        theQueryPlanId = addToQuery(
          'ID',
          '=',
          'where',
          plan_id?.toString(),
          theQueryPlanId
        );
      }
    }

    if (theAssets !== '' && theAssets !== undefined) {
      if (current_query !== '') {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          theAssets?.toString(),
          theQueryAsset
        );
      } else {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          theAssets?.toString(),
          theQueryAsset
        );
      }
    }
    if (theTypes !== '' && theTypes !== undefined) {
      if (current_query !== '') {
        theQueryType = ' and type_code in (' + theTypes + ')';
        current_query += theQueryType;
      } else {
        theQueryType = ' type_code in (' + theTypes + ')';
        current_query += theQueryType;
      }
    }
    if (theResp !== '' && theResp !== undefined) {
      if (current_query !== '') {
        theQueryResp = addToQuery(
          'order_resp_code',
          'in',
          'andWhere',
          theResp?.toString(),
          theQueryResp
        );
      } else {
        theQueryResp = addToQuery(
          'order_resp_code',
          'in',
          'where',
          theResp?.toString(),
          theQueryResp
        );
      }
    }
    if (theDate !== null && theDate) {
      if (theDate.length > 0) {
        if (current_query !== '') {
          var start_date = moment(theDate[0]).format('yyyy-MM-DD');
          var end_date = moment(theDate[1]).format('yyyy-MM-DD');
          theQueryDate = addToQuery(
            'scheduled_start_date',
            '>',
            'andWhere',
            start_date,
            theQueryDate
          );
          theQueryDate += addToQuery(
            'scheduled_start_date',
            '<',
            'andWhere',
            end_date,
            theQueryDate
          );
        } else {
          var start_date = moment(theDate[0]).format('yyyy-MM-DD');
          var end_date = moment(theDate[1]).format('yyyy-MM-DD');
          theQueryDate = addToQuery(
            'scheduled_start_date',
            '>',
            'where',
            start_date,
            theQueryDate
          );
          theQueryDate += addToQuery(
            'scheduled_start_date',
            '<',
            'andWhere',
            end_date,
            theQueryDate
          );
        }
      }
    }
    if (o_asset_code !== '' && o_asset_code !== undefined) {
      if (current_query !== '') {
        theQueryOutterAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          o_asset_code.trim(),
          theQueryOutterAsset
        );
      } else {
        theQueryOutterAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          o_asset_code.trim(),
          theQueryOutterAsset
        );
      }
    }
    if (
      theSearchText &&
      theSearchText !== '' &&
      !theSearchText?.includes('@')
    ) {
      theQuerySearch = '$' + theSearchText;
      current_query = current_query + theQuerySearch;
    }
    if (clearRequest) {
      model = [];
    }
    init_query = current_page_range + '$' + current_query;
    getTableData(current_page_range + '$' + current_query, false, model);
    dispatch(
      setIsPlanSelected({
        isOpPlanSelected: false,
        isOrderPlanSelected: reduxSearchS.isOrderPlanSelected,
        searchCaseOperation: '',
        planId: reduxSearchS.planId,
      })
    );
    dispatch(setSearchCaseOp(''));
  };
  const addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    the_query: string
  ) => {
    the_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    the_query += '?';
    current_query += the_query;
    return the_query;
  };
  const getTableData = async (
    range: string,
    isFromPagging: boolean,
    theModel: Array<any>
  ) => {
    loadingShow(true, 'Loading');
    setData([]);
    current_query = await applyTheRule('uw_operation', 'Cloud Planner');
    let query = init_query?.split('$').pop();

    let start_index = init_query.indexOf('{');
    let end_index = init_query.indexOf('}') + 1;
    let last_query = init_query.substring(start_index, end_index);

    let orderResponse = await getFilteredOrder(last_query, applyTheRule, 'operations-section');
    const orderCodes = new Set(
      orderResponse?.data?.map((order: any) => order.order_code)
    );
    getOperations(range)
      .then((result) => {
        loadingShow(false);
        if (result.data.length === 0 && isFromPagging) {
          current_page--;
        }
        if (orderResponse !== undefined) {
          result.data = result.data?.filter((item: any) =>
            orderCodes.has(item.orderCode)
          );
        }
        result.data.map((res: any) => {
          res.operationSequence = `${res.pm_id} - ${res.operationSequence}`;
          for (var i = 0; i < Object.keys(res).length; i++) {
            if (
              res[Object.keys(res)[i]] !== null &&
              typeof res[Object.keys(res)[i]] !== 'number' &&
              typeof res[Object.keys(res)[i]] !== 'boolean'
            ) {
              res[Object.keys(res)[i]] = res[Object.keys(res)[i]]?.trim();
            }
          }
          theModel.push({
            ...res,
          });
        });
        if (gridCPOp) {
          gridCPOp.dataSource = model;
          gridCPOp.refresh();
        }

        setData(model);
      })
      .catch((er) => {
        loadingShow(false);
        Message.error('Error occured while gettig data');
        if (er.response) {
          Message.error(
            er.response.data +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  };
  const begin = (args: any) => {
    if (args.requestType === 'paging') {
      if (args.currentPage > args.previousPage) {
        if (args.currentPage >= current_page) {
          current_page++;
          var pS = (gridCPOp as GridComponent).pageSettings.pageSize;
          var s_inx = (current_page - 1) * Number(pS) + 1;
          var e_inx = s_inx + (Number(pS) - 1);
          current_page_range = s_inx + '$' + e_inx;
          buildQuery(false, searchText);
        }
      } else if (args.currentPage === args.previousPage) {
        pS = (gridCPOp as GridComponent).pageSettings.pageSize;
        var last_page = model.length / Number(pS);
        current_page = last_page;
      }
    }
    if (args.action === 'edit') {
      SavePointEdit(args.data);
    }
    if (args.action === 'add') {
      SavePointAdd(args.data);
    }
    if (args.requestType === 'delete') {
      SavePointDelete(args.data);
    }
  };
  const SavePointEdit = (data: any) => {
    let duration = moment(new Date(data.scheduled_end_date)).diff(
      new Date(data.scheduled_start_date),
      'hours'
    );
    let the_end_date = data.scheduled_end_date;
    if (data.estHours !== null && data.required !== null) {
      var theDurationResult = Number(data.estHours) / Number(data.required);
      the_end_date = moment(new Date(data.scheduled_start_date))
        .add(theDurationResult, 'h')
        .toDate();
      duration = theDurationResult;
    }
    const first_obj: any = {
      ...data,
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      // required: parseFloat(data.required).toFixed(2),
      // estHours: parseFloat(data.estHours).toFixed(2),
      //i added toString()
      required: data.required?.toString(),
      estHours: data.estHours?.toString(),
      operationId: Number(data.operationId),
      qtyAssigned: '',
      duration: duration?.toString(),
      scheduled_end_date: new Date(the_end_date),
    };
    delete first_obj.materialStatus;
    first_obj.operationSequence = getSecondNumber(first_obj.operationSequence);
    EditOperations(first_obj)
      .then(() => {
        Message.success('Success');
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const SavePointAdd = (data: any) => {
    data.required = data.required.toString();
    AddOperations(data)
      .then(() => {
        Message.success('Success');
        loadingShow(false);
        buildQuery(true, searchText);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const SavePointDelete = (data: any) => {
    DeleteOperations(data)
      .then(() => {
        Message.success('Success');
        loadingShow(false);
        buildQuery(true, searchText);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  };
  const getColor = async () => {
    let theData = await getPriority();
    setPriorityColorData(theData);
  };
  const priorityColor = (args: any) => {
    let color = PriorityColorData.find(
      (x: any) => x.priority_code?.trim() === args?.priority?.trim()
    )?.priority_color;
    return (
      <div
        style={{
          backgroundColor: color,
          borderRadius: 7,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span>{args.priority}</span>
      </div>
    );
  };
  const itemTemplateShiftColor = (data: any): JSX.Element => {
    return (
      <span>
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.rostercolor }}
        ></span>
        <span>{data.rosterCode + ' - ' + data.description}</span>
      </span>
    );
  };
  const materialColor = (args: any) => {
    return (
      <div
        style={{
          backgroundColor: args.materialStatus,
          borderRadius: 7,
          width: '20px',
          height: '20px',
        }}
      >
        <span> </span>
      </div>
    );
  };
  const contextMenuClick = (args: any) => {
    if (args.item.id === 'materials') {
    }
  };
  const actionComplete = (args: any) => {
    if (args.requestType == 'filterafteropen') {
      if (args.filterModel.dlgDiv.querySelector('.e-autocomplete')) {
        args.filterModel.dlgDiv.querySelector(
          '.e-autocomplete'
        ).ej2_instances[0].autofill = false;
      }
    }
  };
  const clearFilter = () => {
    priorityFMCComValue = [];
    statusFMCComValue = [];
    typeFMCComValue = [];
    respFMCComValue = [];
    setSchdeduleStartDateVal([]);
    if (current_query !== '') {
      buildQuery(true, searchText);
    }
  };
  const StatusMultiSelect = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            statusFMCCom = scope;
          }}
          field={{ value: 'value', text: 'alias' }}
          id='operationFilterMultiStatus'
          url='global-filter?where=operation$status$isEnabled€1'
          placeHolder='Select a Status'
          value={statusFMCComValue}
          onChange={(e: any) => {
            statusFMCComValue = e.value;
          }}
        />
      </>
    );
  };
  const PriorityMultiSelect = React.memo(() => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => { }}
          field={{ value: 'value', text: 'alias' }}
          id='operationFilterMultiPriority'
          url='global-filter?where=operation$priority$isEnabled€1'
          placeHolder='Select a Priority'
          value={priorityFMCComValue}
          onChange={(e: any) => {
            priorityFMCComValue = e.value;
          }}
        />
      </>
    );
  });
  const AssetInput = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            assetFMCCom = scope;
          }}
          query={queryOfAsset}
          field={{ text: 'assetCode', value: 'assetCode' }}
          placeHolder='Select a Asset'
          id='operationFilterMultiAsset'
          url='assets/search'
          value={assetFMCComValue}
          allowFiltering={true}
          onChange={(e: any) => {
            assetFMCComValue = e.value;
          }}
        />
      </>
    );
  };
  const TypeInput = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            typeFMCCom = scope;
          }}
          field={{ value: 'sys_tbl_code', text: 'sys_description' }}
          id='operationFilterMultiType'
          url='system-config?where=P3'
          placeHolder='Select a Type'
          value={typeFMCComValue}
          onChange={(e: any) => {
            typeFMCComValue = e.value;
          }}
        />
      </>
    );
  };
  const RespInput = () => {
    return (
      <GlobalMultiSelection
        refDD={(scope: MultiSelectC) => {
          respFMCCom = scope;
        }}
        field={{ value: 'sys_tbl_code', text: 'sys_description' }}
        id='operationFilterMultiResp'
        url='system-config?where=P2'
        placeHolder='Select a Resp'
        onChange={(e: any) => {
          respFMCComValue = e.value;
        }}
        value={respFMCComValue}
      />
    );
  };
  const ScheduleStartDateInput = () => {
    return (
      <div>
        <DateRangePickerComponent
          placeholder='Schedule Start Date'
          format={'dd/MM/yyyy'}
          enabled={true}
          showClearButton={true}
          value={schdeduleStartDateVal}
          onChange={(e: any) => {
            setSchdeduleStartDateVal(e.value);
          }}
        ></DateRangePickerComponent>
      </div>
    );
  };
  const FilterPrio = () => {
    buildQuery(true, searchText);
  };
  useEffect(() => {
    const get = async () => {
      await getColor();
    };
    get();
    return () => { };
  }, []);
  useEffect(() => {
    if (
      reduxSearchS.isOpPlanSelected &&
      (reduxSearchS.searchCaseOperation === '' ||
        !reduxSearchS.searchCaseOperation)
    ) {
      plan_id = reduxSearchS.planId;
      getBusinessLogic();
    }
  }, [reduxSearchS.isOpPlanSelected]);

  useEffect(() => {
    searchTextBox && (searchTextBox.value = searchText);
    PriorityColorData?.map((elCol: any) => {
      $(`.e-chip-text${elCol.priority_code?.trim()}`).css(
        'background-color',
        `${elCol?.priority_color}`
      );
      var el = document.getElementsByClassName(
        `e-chip-text${elCol.priority_code?.trim()}`
      )[0] as any;
      if (el) {
        el.style.backgroundColor = elCol?.priority_color;
      }
    });
  });
  useEffect(() => {
    if (
      reduxSearchS.searchCaseOperation &&
      reduxSearchS.searchCaseOperation !== ''
    ) {
      $('#operation-search').val(reduxSearchS.searchCaseOperation);
      searchText = reduxSearchS.searchCaseOperation;
      buildQuery(true, reduxSearchS.searchCaseOperation);
    }
  }, [reduxSearchS.searchCaseOperation]);

  const queryCellInfo = (args: any) => {
    if (
      args.column.field === 'estHours' ||
      args.column.field === 'duration' ||
      args.column.field === 'required'
    ) {
      args.cell.innerHTML = Number(args.cell.innerHTML).toFixed(2);
    }

    if (
      args.column &&
      args.column.type === 'checkbox' &&
      args.data &&
      args.cell
    ) {
      let theData = args.data as any;
      if (theData) {
        let isEffected = theData.isEffected;
        let theCurrenColor = 'tranparent';
        if (isEffected) {
          theCurrenColor = '#8ECDDD';
        }
        args.cell.setAttribute('style', `background-color:${theCurrenColor};`);
      }
    }
  };
  const toolbarClick = (args: any) => {
    if (args.item.id === 'refresh') {
      getBusinessLogic();
    }
    if (args.item.id === 'show_order') {
      if (gridCPOp.getSelectedRecords().length > 0) {
        let theDatas = gridCPOp.getSelectedRecords();
        let theCodes = theDatas
          .map((theData: any) => {
            return theData.orderCode;
          })
          .toString();
        dispatch(setSearchCaseOrder(theCodes));
        dispatch(setSearchCaseOp(''));
      }
    }
    if (args.item.id === 'show_resources') {
      if (gridCPOp.getSelectedRecords().length > 0) {
        let theDatas = gridCPOp.getSelectedRecords();
        let theCodes = theDatas
          .map((theData: any) => {
            return theData.orderCode;
          })
          .toString();
        dispatch(setSearchCaseGantt(theCodes));
      }
    }
  };
  return (
    <div>
      <GlobalSearch
        id={'cloud-planner-op-filter'}
        height={'416px'}
        applyFilter={FilterPrio.bind(this)}
        clearFilter={clearFilter.bind(this)}
        Component1={PriorityMultiSelect}
        Component2={StatusMultiSelect}
        Component3={AssetInput}
        Component4={TypeInput}
        Component5={RespInput}
        Component6={ScheduleStartDateInput}
      />
      <GridComponent
        id='cloudplanner-op-grid'
        dataSource={data}
        editSettings={editOptions}
        toolbar={toolbarOptions}
        ref={(g: GridComponent) => (gridCPOp = g)}
        filterSettings={FilterOptions}
        allowFiltering={true}
        allowSorting={true}
        showColumnChooser={true}
        statelessTemplates={['toolbarTemplates']}
        dataBound={() => {
          var searchEle = gridCPOp?.element?.querySelector(
            '#' + gridCPOp.element.id + '_searchbar'
          );
          if (searchEle) {
            searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
          }
        }}
        allowPaging={true}
        showColumnMenu={true}
        toolbarClick={toolbarClick}
        pageSettings={pageOptions}
        allowReordering={true}
        allowResizing={true}
        allowGrouping={true}
        actionComplete={actionComplete.bind(this)}
        style={{ marginTop: '10px' }}
        actionBegin={begin.bind(this)}
        gridLines='Both'
        height='calc(-270px + 100vh)'
        contextMenuItems={contextMenuItems}
        contextMenuClick={contextMenuClick.bind(this)}
        queryCellInfo={queryCellInfo.bind(this)}
      >
        <ColumnsDirective>
          <ColumnDirective type='checkbox' width={35} allowEditing={false} />
          <ColumnDirective
            allowEditing={false}
            width={90}
            template={priorityColor.bind(this)}
            field='priority'
            headerText='Priority'
            clipMode='EllipsisWithTooltip'
          // edit={getParamsDD(
          //   { value: 'value', text: 'alias' },
          //   'priority',
          //   'global-filter?where=operation$priority$isEnabled€1',
          //   true
          // )}
          />
          <ColumnDirective
            field='materialStatus'
            allowEditing={false}
            template={materialColor.bind(this)}
            headerText='Material Status'
            width={50}
            clipMode='EllipsisWithTooltip'
          />

          <ColumnDirective
            allowEditing={false}
            field='assetCode'
            headerText='Asset Number'
            width={150}
            clipMode='EllipsisWithTooltip'
          // edit={assetParams}
          />
          <ColumnDirective
            allowEditing={false}
            field='orderCode'
            headerText='Work Order Number'
            width={150}
            clipMode='EllipsisWithTooltip'
          // edit={orderParams}
          />
          <ColumnDirective
            field='orderDescription'
            headerText='WO Description'
            clipMode='EllipsisWithTooltip'
            allowEditing={false}
          />
          <ColumnDirective
            allowEditing={true}
            field='operationSequence'
            headerText='Op Sequence'
            width={150}
            clipMode='EllipsisWithTooltip'
          />
          <ColumnDirective
            field='operationDescription'
            headerText='Task Description'
            clipMode='EllipsisWithTooltip'
            allowEditing
          />
          <ColumnDirective
            field='tradeCode'
            headerText='Trade'
            width={150}
            clipMode='EllipsisWithTooltip'
            edit={getParamsDD(
              { text: 'trade_code', value: 'trade_code' },
              'tradeCode',
              'trade'
            )}
          />
          {process.env.REACT_APP_ERP_TYPE == 'MEX' ? null : (
            <ColumnDirective
              allowEditing={false}
              field='responsibility'
              headerText='Responsibility'
              width={150}
              clipMode='EllipsisWithTooltip'
            // edit={getParamsDD(
            //   { value: 'sys_tbl_code', text: 'sys_description' },
            //   'responsibility',
            //   'system-config?where=P2',
            //   true
            // )}
            />
          )}
          <ColumnDirective
            field='required'
            headerText='Required'
            editType='numericedit'
            width={150}
            clipMode='EllipsisWithTooltip'
            format='C2'
            allowEditing={false}
          />
          <ColumnDirective
            field='estHours'
            headerText='Est Hours'
            editType='numericedit'
            width={150}
            clipMode='EllipsisWithTooltip'
            format='C2'
            allowEditing={false}
          />

          <ColumnDirective
            field='shift'
            headerText='Shift'
            allowEditing={true}
            width={150}
            clipMode='EllipsisWithTooltip'
            edit={getParamsDD(
              { text: 'rosterCode', value: 'rosterId' },
              'shift',
              'shift'
            )}
          />
          <ColumnDirective
            field='workOrderType'
            headerText='Work Order Type'
            allowEditing={false}
            width={200}
            clipMode='EllipsisWithTooltip'
          // edit={getParamsDD(
          //   { value: 'sys_tbl_code', text: 'sys_description' },
          //   'workOrderType',
          //   'system-config?where=P3',
          //   true
          // )}
          />
          <ColumnDirective
            allowEditing={false}
            field='section'
            width={150}
            headerText='Section'
            clipMode='EllipsisWithTooltip'
          // edit={getParamsDD(
          //   { value: 'sys_tbl_code', text: 'sys_description' },
          //   'workOrderType',
          //   'system-config?where=N4',
          //   true
          // )}
          />
          <ColumnDirective
            allowEditing={false}
            field='order_status_code'
            headerText='WO Status'
            width={150}
            clipMode='EllipsisWithTooltip'
          />
          <ColumnDirective
            field='scheduled_start_date'
            headerText='Scheduled Start Date'
            allowEditing={false}
            width={200}
            clipMode='EllipsisWithTooltip'
            type='datetime'
            format='dd/MM/yyyy HH:mm'
            edit={{ params: { format: 'dd/MM/yyyy HH:mm' } }}
          />
          <ColumnDirective
            field='scheduled_end_date'
            headerText='Scheduled Finish Date'
            allowEditing={false}
            width={200}
            clipMode='EllipsisWithTooltip'
            type='datetime'
            format='dd/MM/yyyy HH:mm'
          />
          <ColumnDirective
            field='plannedStartDate'
            headerText='Planned Start Date'
            allowEditing={false}
            width={200}
            clipMode='EllipsisWithTooltip'
            type='datetime'
            format='dd/MM/yyyy HH:mm'
            edit={{ params: { format: 'dd/MM/yyyy HH:mm' } }}
          />
          <ColumnDirective
            field='planned_end_date'
            headerText='Planned End Date'
            allowEditing={false}
            width={200}
            clipMode='EllipsisWithTooltip'
            type='datetime'
            format='dd/MM/yyyy HH:mm'
          />
          <ColumnDirective
            allowEditing={false}
            field='actHours'
            headerText='Actual Hours'
            width={150}
            clipMode='EllipsisWithTooltip'
          />
          <ColumnDirective
            allowEditing={false}
            field='statusCode'
            headerText='Status'
            width={150}
            clipMode='EllipsisWithTooltip'
          // edit={getParamsDD(
          //   { value: 'value', text: 'alias' },
          //   'statusCode',
          //   'global-filter?where=operation$status$isEnabled€1'
          // )}
          />
          <ColumnDirective
            allowEditing={false}
            field='plannedBy'
            headerText='Planned By'
            width={150}
            clipMode='EllipsisWithTooltip'
          />
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ColumnMenu,
            Resize,
            Reorder,
            ContextMenu,
            Group,
            Sort,
          ]}
        />
      </GridComponent>
      <GlobalDialog
        showDialog={hideDeleteDialog}
        setShowDialog={(val: boolean) => setHideDeleteDialog(val)}
        header={`Confirm Shift Assign`}
        width={'222px'}
        hideDoneButton={true}
        buttons={buttonShiftAssignment}
      >
        <GlobalDropDown
          id='cloudplanner-operations-shift'
          placeHolder='Shift'
          url='shift'
          field={{ text: 'rosterCode', value: 'rosterId' }}
          refDD={(scope: DropDownListComponent) =>
            (dropDownListObjectShiftElment = scope)
          }
          itemTemplate={itemTemplateShiftColor}
          floatLabelType='Always'
        />
      </GlobalDialog>
    </div>
  );
};
export default Operations;
